import { render, staticRenderFns } from "./SelectDifficulty.vue?vue&type=template&id=2f73b04c&scoped=true&"
import script from "./SelectDifficulty.vue?vue&type=script&lang=js&"
export * from "./SelectDifficulty.vue?vue&type=script&lang=js&"
import style0 from "./SelectDifficulty.vue?vue&type=style&index=0&id=2f73b04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73b04c",
  null
  
)

export default component.exports